var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertColorsContraste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#FFF333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H20V20H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.667,4.409V16.234a4.95,4.95,0,0,1-5-4.892,4.8,4.8,0,0,1,1.458-3.45l3.542-3.483M5.958,6.7h0A6.505,6.505,0,0,0,4,11.342,6.61,6.61,0,0,0,10.667,17.9a6.61,6.61,0,0,0,6.667-6.558A6.505,6.505,0,0,0,15.375,6.7h0L11.25,2.642a.835.835,0,0,0-1.167,0Z",
    transform: "translate(-0.667 -0.401)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertColorsContraste);
export default __webpack_public_path__ + "static/media/invertColorsContraste.56c002f4bd07eeb31a997bc0492e4c47.svg";
export { ForwardRef as ReactComponent };